import React, { useCallback } from 'react'
import { View } from 'react-native'

import { IconButton, Txt } from '../../../../components'
import styles from './styles'
import { useNavigation } from '@react-navigation/native'
import { usePlatforms } from '../../../../hooks/usePlatforms'

const Header = () => {
  const navigation = useNavigation()
  const { isTablet } = usePlatforms()

  const onGoBack = useCallback(() => {
    if (navigation.canGoBack()) {
      navigation.goBack()
    } else {
      navigation.navigate('main')
    }
  }, [navigation])

  return (
    <>
      <View style={styles.container}>
        <IconButton
          icon='LeftArrow'
          onPress={onGoBack}
          color='GALLERY'
          iconColor='SLATE_GRAY_TEXT'
          size={30}
          iconSize={16}
          testID='preferredLanesHeaderOnGoBackButton'
          accessibilityLabel='preferredLanesHeaderOnGoBackButton'
        />
        {!isTablet && (
          <Txt
            text='Preferred Lanes'
            identity='h3'
            style={styles.title}
          />
        )}
      </View>
    </>
  )
}

export default Header
